// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__7xl9l","navbarButton":"NavBar_navbarButton__XAnkU","active":"NavBar_active__3eA7X","inactive":"NavBar_inactive__dv7ix"};